fragment ContentBlockTable on contentBlocks_table_BlockType {
    sectionTitle
    captionTop
    richTextTable
    captionBottom

    anchorId
    anchorLabel
}
